import { List, ListItem } from "@chakra-ui/react";
import React from "react";
import SearchResult from "./SearchResult";

export type ISearchResults = {
  onCloseModal: () => void;
  results: any[];
  query: string;
};

const SearchResults = ({ onCloseModal, results, query }: ISearchResults) => {

  const SearchList = ({ results, query }: any) => {
    return results && results.length > 0 ? (
      <List p="0" pt="1em">
        {results && results.length > 0
          ? results.map((result: any, i: number) => (
              <SearchResult result={result} onCloseModal={onCloseModal} index={i} key={i} />
            ))
          : null}
      </List>
    ) : (
      <List p="0" pt="1em">
        <ListItem
          sx={{ background: "#fff", borderRadius: "md", m: 5, mt: 0, p: 4 }}
        >
          {query && query.length >= 3
            ? "No Results Found"
            : "Please enter a search term"}
        </ListItem>
      </List>
    );
  };

  return SearchList({ results, query });
}

export default React.memo(SearchResults);
